import React from 'react';

export const PlaceholderPersonIcon = () => (
  <svg width="100%" height="80%" viewBox="0 0 149 194" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.25 136.25C0.25 122.576 11.4122 111.5 25.1114 111.5H123.889C137.625 111.5 148.75 122.563 148.75 136.324V191.269C148.75 233.406 0.25 233.406 0.25 191.269V136.25Z" />
    <path d="M74.5 99.125C101.838 99.125 124 76.9631 124 49.625C124 22.2869 101.838 0.125 74.5 0.125C47.1619 0.125 25 22.2869 25 49.625C25 76.9631 47.1619 99.125 74.5 99.125Z" />
  </svg>
);
